import { Button } from '@/components/ui/button'
import { Container } from '@/components/ui/container'

import { useFormExtended } from './form'

function FormHelperFooterAction() {
	const ctx = useFormExtended()
	console.log({
		ctx,
	})

	return (
		<div className="flex items-center justify-end gap-x-2 p-4">
			<Button
				variant="secondary"
				size="small"
				type="button"
				onClick={ctx.onCancel}
			>
				Batal
			</Button>
			<Button type="submit" size="small" isLoading={ctx.isPending}>
				Simpan
			</Button>
		</div>
	)
}

export const FormHelper = Object.assign(
	{},
	{
		FooterContainer: Container,
		FooterAction: FormHelperFooterAction,
	}
)
